<div class="main-input-set">
  <app-top-stepper></app-top-stepper>
  <div class="auto-upload-file">
    <div class="auto-upload-file__heading">
      Upload the data you want to analyze
    </div>
    <div class="auto-upload-file__outer" appFiledrop (click)="click.click()" (filesChangeEmiter)="onFileChange($event,'drop')">
      <input #click
      type="file"
      class="auto-upload-file__input-tag"
      (change)="onFileChange($event,'input')"
    />
      <div class="auto-upload-file__default-view" *ngIf="!uploadedFileName" >
        <img src="../../../../../assets/images/svg/upload-img.svg" alt="" class="auto-upload-file__img" />
        <div class="auto-upload-file__bold-txt">
          Drag & Upload to Analyze <span>Or Browse</span>
        </div>
        <div class="auto-upload-file__light-txt">
          Supported .csv format, max size 5MB
        </div>
      </div>
      <div class="auto-upload-file__uploaded-file" *ngIf="uploadedFileName" >
        {{ uploadedFileName }}
      </div>
  
    </div>
    <button *ngIf="uploadedFileName" class="auto-upload-file__btn" (click)="uploadedFileName? upload():''">
       Upload 
       <img *ngIf="!isLoading" src="../../../../../assets/images/svg/upload-outline.svg" alt="">
       <app-circle-loader *ngIf="isLoading"  color="white"></app-circle-loader>
    </button>
  </div>
  <div class="auto-ml-page__bottom-sec">
      <object data="assets/images/svg/chart-moving-animation.svg" type="">
  
      </object>
      <object data="assets/images/svg/analyze-animated.svg" type="" class="auto-ml-page__magnifying-glass"></object>
  </div>
</div>
